// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.development-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 6em;
  text-align: center;
}

.development-container .mt-2 {
  margin-top: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/development/development.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AACD;;AACA;EACC,gBAAA;AAED","sourcesContent":[".development-container {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tmargin-top: 6em;\n\ttext-align: center;\n}\n.development-container .mt-2{\n\tmargin-top: 30px;\n }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
